import type { z } from "zod";

import { ServiceCategoryEntity } from "../../../model";

const zOutSchema = ServiceCategoryEntity.zSchema
  .pick({
    id: true,
  })
  .extend({
    name: ServiceCategoryEntity.zPossiblyEmptyName.nullable(),
    description: ServiceCategoryEntity.zPossiblyEmptyDescription.nullable(),
  });
type OutSchema = z.infer<typeof zOutSchema>;

export { zOutSchema };
export type { OutSchema };
